var Cacheable = /** @class */ (function () {
    /**
     * Constructor detail
     * @param key
     * @param item
     * @param ts
     * @param maxAge
     */
    function Cacheable(key, item, ts, maxAge) {
        /** @Override */
        this.error = false; // error occured when itm was last refreshed 
        this.key = key;
        this.item = item;
        this.ts = ts;
        this.maxAge = maxAge;
    }
    return Cacheable;
}());
export { Cacheable };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/lib/cache/cacheable.cls.ts
// module id = null
// module chunks = 